import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { editDeviation } from '@wix/da-shared-react/pkg/redux/deviations/actionCreators';
import { AppState } from '../../../../../../../types/store';
import { isCurrentUserProfileOwner } from '../../../../../../selectors/users';
import { getModuleDataByModuleType } from '../../../../../../selectors/modules';
import { ModuleType } from '../../../../../../../types/modules';
import { pinPostOnFeed } from '../../../../../../actions/feed';
import { Props } from './JournalFeedThumb';

type StateProps = Pick<Props, 'isCurrentUserProfileOwner' | 'isPinned'>;
type DispatchProps = Pick<Props, 'onPin' | 'onUnpin' | 'onEdit'>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

// TODO: except for delete this is identical to PostEditableItem.container.ts

// TODO: cannot rely solely on deviationId, pseudo-deviations ids can collide
// with deviationIds. item typeIds must be taken into consideration as well.
const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  ownProps
) => {
  const pinnedDeviationId = getModuleDataByModuleType(
    state,
    ModuleType.FEED_PINNED_DEVIATION
  ).itemId;
  return {
    isCurrentUserProfileOwner: isCurrentUserProfileOwner(state),
    isPinned: pinnedDeviationId === ownProps.item.deviationId,
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (
  dispatch,
  { item }
) => ({
  onPin: () => dispatch(pinPostOnFeed({ item })),
  onUnpin: () => dispatch(pinPostOnFeed({ item: undefined })),
  onEdit: () => dispatch(editDeviation({ deviation: item })),
});

export default connect(mapStateToProps, mapDispatchToProps);
